var render = function render(){var _vm=this,_c=_vm._self._c;return _c('highcharts',{directives:[{name:"waypoint",rawName:"v-waypoint",value:(_vm.wayPointConfig),expression:"wayPointConfig"}],ref:"chart",staticClass:"inline-chart",attrs:{"options":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }